<template>
    <div>
        <i @click="toggleShortList"
           class="mdi mdi-star-outline star"
           title="Add to shortlist"
           v-if="!vehicle.is_shortlist"/>
        <i @click="toggleShortList"
           class="mdi mdi-star star"
           title="Remove from shortlist"
           v-else/>
    </div>
</template>

<script>
    import Vehicle from "@/models/vehicle";

    export default {
        props: {
            vehicle: {
                type: Object,
                required: true
            }
        },
        methods: {
            toggleShortList() {
                if (this.vehicle.is_shortlist) {
                    Vehicle.removeFromShortlist(this.vehicle.id)
                        .then(() => {
                            this.vehicle.is_shortlist = false;
                            this.$notify({
                                title: 'Success',
                                message: 'Successfully removed from shortlist.',
                                type: 'success'
                            });
                            this.$emit('removedFromShortlist', this.vehicle);
                        });
                } else {
                    Vehicle.addToShortlist(this.vehicle.id)
                        .then(() => {
                            this.vehicle.is_shortlist = true;
                            this.$notify({
                                title: 'Success',
                                message: 'Successfully added to shortlist.',
                                type: 'success'
                            });
                            this.$emit('removedFromShortlist', this.vehicle);
                        })
                }
            }
        }
    }
</script>

<style scoped>

</style>
